import axiosInstance from "./axiosInstance";

const pickingService = {
  create: async (payload) => {
    try {
      const response = await axiosInstance.post("/picking/create", payload);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  getAll: async () => {
    try {
      const response = await axiosInstance.get("/picking/all"); 
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  getSingle: async (id) => {
    try {
      const response = await axiosInstance.get(`/picking/single/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  place: async (id, payload) => {
    try {
      const response = await axiosInstance.put(`/picking/place/${id}`, payload);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};

export default pickingService;
